import { FC, useEffect, useRef, useState } from 'react'

import { Container } from 'components/container'
import { Menu, Toggle } from './menu'
import { MenuContextProvider } from './menu/menu-context'
import {
  StyledHeader,
  Logo,
  LogoContainer,
  MenuContainer,
  ObservedPoint,
} from './styled'

export const Header: FC<{
  onTop?: boolean
  isTransparent: boolean
  inverted: boolean
}> = ({ onTop, isTransparent, inverted }) => {
  const pointRef = useRef<HTMLDivElement>(null)
  const [hasScrolled, setHasScrolled] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([point]) => {
      setHasScrolled(!point.isIntersecting)
    })

    if (pointRef.current) {
      observer.observe(pointRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <MenuContextProvider>
      <ObservedPoint ref={pointRef} />
      <StyledHeader
        $onTop={onTop}
        isTransparent={isTransparent}
        hasScrolled={hasScrolled}
      >
        <Container $fluid>
          <LogoContainer title="CurrentTime" href="/">
            <Logo />
          </LogoContainer>
        </Container>
      </StyledHeader>
      <Menu inverted={inverted} />

      <MenuContainer>
        <Toggle />
      </MenuContainer>
    </MenuContextProvider>
  )
}
